import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { setFormValue } from 'redux/modules/newAffiliate';
import { getProducts } from 'redux/modules/products';
import * as styles from './BillingDetail.scss';
var ChangeProduct = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    products: state.products.productsByOrgId,
    selectedProduct: state.newAffiliate.affiliateConfig && state.newAffiliate.affiliateConfig.affiliateProductId ? state.newAffiliate.affiliateConfig.affiliateProductId : null
  };
}, {
  getProducts: getProducts,
  setFormValue: setFormValue
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ChangeProduct, _Component);

  var _super = _createSuper(ChangeProduct);

  function ChangeProduct() {
    var _this;

    _classCallCheck(this, ChangeProduct);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "formatCurrency", function (amount) {
      var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var amountInDollars = cents ? amount / 100.0 : amount;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(amountInDollars);
    });

    _defineProperty(_assertThisInitialized(_this), "renderProductLabel", function (product) {
      var showAllFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return /*#__PURE__*/React.createElement("div", null, product.title && /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 17,
          borderBottom: '1px solid gray',
          paddingBottom: 4,
          marginBottom: 4
        }
      }, product.title), showAllFields && product.description && /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 13
        }
      }, product.description), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 15,
          fontWeight: 'bold'
        }
      }, "Total Monthly Price: ", _this.formatCurrency(product.retailMonthlyPrice)), parseInt(product.adsBudget, 10) !== 0 && /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 13
        }
      }, "Includes ", _this.formatCurrency(product.adsBudget), "/mo ads budget."), parseInt(product.retailSetupFee, 10) !== 0 && showAllFields && /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 13
        }
      }, "Setup Fee: ", _this.formatCurrency(product.retailSetupFee)));
    });

    return _this;
  }

  _createClass(ChangeProduct, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.products.length) {
        this.props.getProducts(this.props.partnerDetails.contract.OrganizationId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var products = this.props.products[this.props.partnerDetails.contract.OrganizationId] ? this.props.products[this.props.partnerDetails.contract.OrganizationId] : [];
      console.log('here we are...');
      console.log(this.props.clientDetails);
      var currentProduct = {
        title: this.props.clientDetails.product_title,
        retailSetupFee: this.props.clientDetails.contractProduct_setupFee * 100,
        retailMonthlyPrice: this.props.clientDetails.contractProduct_monthlyFee * 100,
        adsBudget: this.props.clientDetails.contractProduct_monthlyAdsBudget * 100
      };
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-around'
        },
        id: "ChangeProduct"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '0 0 45%',
          padding: '16px 0'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#333333',
          paddingBottom: 24
        }
      }, "The current product for ", this.props.clientDetails.organization_name, /*#__PURE__*/React.createElement("div", {
        style: {
          border: '1px solid #616161',
          borderRadius: 2,
          lineHeight: '22px',
          padding: 16,
          marginTop: 24
        }
      }, this.renderProductLabel(currentProduct, true)))), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '0 0 45%',
          padding: '16px 0'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#333333',
          paddingBottom: 24
        }
      }, "Select the new product for ", this.props.clientDetails.organization_name), !!products.length && /*#__PURE__*/React.createElement(RadioButtonGroup, {
        name: "products",
        defaultSelected: this.props.selectedProduct,
        onChange: function onChange(e, val) {
          _this2.props.setFormValue('affiliateProductId', 'affiliateConfig', val);
        }
      }, products.map(function (product, index) {
        return /*#__PURE__*/React.createElement(RadioButton, {
          disabled: parseInt(product.id, 10) === parseInt(_this2.props.clientDetails.contractProduct_ProductId),
          value: product.id,
          label: _this2.renderProductLabel(product),
          key: "productRadio_".concat(index),
          style: {
            marginBottom: 12
          }
        });
      }))));
    }
  }]);

  return ChangeProduct;
}(Component)) || _class);
export { ChangeProduct as default };